// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  ContainerServiceContext,
  ContainerServiceClientOptionalParams,
} from "./containerServiceContext.js";
export { createContainerService } from "./containerServiceContext.js";
